import extend from '@enums/extend';

export enum WorkspaceObjectType {
  Folder = 1,
  ProjectParent = 2,
  File = 3,
  Workspace = 4
}

export enum WorkspaceObjectRole {
  Collaborator = 1,
  Viewer = 2,
  Owner = 3,
}

export enum WorkspaceType {
  Personal = 1,
  Group = 2
}

const typeMap = new Map([
  [WorkspaceObjectType.Folder,         { name: 'Folder'  }],
  [WorkspaceObjectType.ProjectParent,  { name: 'Project'   }],
  [WorkspaceObjectType.Workspace,      { name: 'Workspace'   }],
]);

const roleMap = new Map([
  [WorkspaceObjectRole.Collaborator,  { name: 'Collaborator'  }],
  [WorkspaceObjectRole.Viewer,        { name: 'Viewer'   }],
  [WorkspaceObjectRole.Owner,         { name: 'Owner'   }],
]);

export default {
  WorkspaceObjectRole: extend(roleMap),
  WorkspaceObjectType: extend(typeMap),
};